import { gql, useQuery } from '@apollo/client';

export const GET_APPRAISAL_INTERVIEW_BY_ID = gql`
  query getAppraisalInterviewById($appraisalInterviewId: ObjectId!) {
    getAppraisalInterviewById(appraisalInterviewId: $appraisalInterviewId) {
      _id
      interviewType {
        name
        fieldsHeadlines
      }
      interviewName
      setTo
      status
      createdByMember {
        profile {
          displayName
        }
      }
      createdAt
      feedback
      interviewArticles {
        headline
        description
      }
    }
  }
`;

export const useGetAppraisalInterviewById = (appraisalInterviewId?: string) => {
  const { data, loading } = useQuery(GET_APPRAISAL_INTERVIEW_BY_ID, {
    variables: {
      appraisalInterviewId,
    },
    skip: !appraisalInterviewId,
    fetchPolicy: 'network-only',
  });

  return {
    loading,
    appraisalInterview: data?.getAppraisalInterviewById || {},
  };
};
